import React from 'react';

import cs from 'classnames';
import { differenceInDays } from 'date-fns';
import { CaptionLabel, Day, DayButton, Week } from 'react-day-picker';

import { DatePicker } from '../DatePicker';
import { DAY_OFFSET, MAX_DAYS } from './constants';
import { getPickerOptions } from './functions';
import s from './index.module.css';
import type { TProps } from './types';

export const DayPicker = function (props: TProps) {
  const pickerOptions = getPickerOptions(props);
  const getDayNumber = (date: Date) => differenceInDays(date, pickerOptions?.startMonth || 0) + DAY_OFFSET;

  const renderDayButton = React.useCallback<typeof DayButton>((props) => {
    const dayNumber = getDayNumber(props.day.date);
    return <DayButton {...props}>{dayNumber}</DayButton>;
  }, []);

  const renderWeek = React.useCallback<typeof Week>((params) => {
    if (params.week.days.length < 7) return null;
    return <Week {...params} />;
  }, []);

  const renderDay = React.useCallback<typeof Day>((params) => {
    const isHidden = getDayNumber(params.day.date) > MAX_DAYS;
    return <Day {...params} className={cs(params.className, { [s.day_hidden]: isHidden })} />;
  }, []);

  const renderCaptionLabel = React.useCallback<typeof CaptionLabel>((params) => {
    const label = props.mode === 'range' ? 'Select a day or day range' : 'Select a day';
    return <CaptionLabel {...params}>{label}</CaptionLabel>;
  }, []);

  return (
    <DatePicker
      captionLayout="label"
      components={{
        Day: renderDay,
        DayButton: renderDayButton,
        Week: renderWeek,
        CaptionLabel: renderCaptionLabel,
        Weekdays: () => null,
      }}
      {...pickerOptions}
    />
  );
};
